import { actions } from "../actions/travel";

// const initialState = {
//   isLoggedIn: true,
//   travelDetails: {
//     contactNumber: "556975813",
//     deptDate: "2022-05-14",
//     email: "AQasem@tawuniya.com.sa",
//     flightNumber: "sv1035",
//     nationalId: "2342963010",
//     productCode: "DC",
//     returnDate: "2022-05-25",
//     yearBirth: "1995-08-25",
//   },
//   flightCovered: "30",
//   travelProposal: {
//     duration: "6",
//     PriceDetails: [
//       {
//         totalPremimum: "12.0",
//         VATAmount: "5.55",
//         GrandTotal: "42.55",
//         totalMemberAmount: "12.0",
//         VATableAmount: "37.0",
//         VATPercentage: "15",
//         adminFee: "25",
//         PromotionDiscount: null,
//       },
//     ],
//     productCode: "ST",
//     ApplicantDetails: [
//       { premiumAmount: "12", dob: "1994-10-08", name: "ABDULRAHMAN HAFIZMO" },
//     ],
//     coverCode: "DC",
//     status: "SUCCESS",
//   },
//   applicants: {
//     self: {
//       nationalId:"1089811309"
//     },
//     applicants: [],
//   },
//   selectedFeatures: [],
//   travelQuotation:{},
//   flightDelayQuotation:{},
//   bundleQuotation:{}

// }

const initialState = {
  loading: false,

  isLoggedIn: false,
  proposalRequest: {},
  travelProposal: {},
  travelDetails: {},
  flightProposal: {},
  flightCovered: "90",
  applicants: {
    self: {},
    applicants: [],
  },
  selectedFeatures: [],
  travelQuotation: {},
  flightDelayQuotation: {},
  bundleQuotation: {},
  isWorldcup: false,
  travelGoogleTaggingData: {},
  businessLine:''
};

const travelReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_LOADER:
      return { ...state, loading: action.payload };
    case actions.UPDATE_TRAVEL_DETAILS:
      return { ...state, travelDetails: action.payload };
    case actions.UPDATE_FLIGHT_PROPOSAL:
      return { ...state, flightProposal: action.payload };
    case actions.UPDATE_TRAVEL_PROPOSAL:
      return { ...state, travelProposal: action.payload };
    case actions.UPDATE_APPLICANT:
      return { ...state, applicants: action.payload };
    case actions.UPDATE_FLIGHT_COVER:
      return { ...state, flightCovered: action.payload };
    case actions.UPDATE_SELECTED_FEATURES:
      return { ...state, selectedFeatures: action.payload };
    case actions.SET_IS_LOGGEDIN:
      return { ...state, isLoggedIn: action.payload };

    case actions.UPDATE_TRAVEL_QUOTATION:
      return { ...state, travelQuotation: action.payload };
    case actions.UPDATE_Flight_QUOTATION:
      return { ...state, flightDelayQuotation: action.payload };
    case actions.UPDATE_BUNDLE_QUOTATION:
      return { ...state, bundleQuotation: action.payload };
    case actions.UPDATE_PROPOSAL_REQUEST:
      return { ...state, proposalRequest: action.payload };

    case actions.UPDATE_IS_WORLD_CUP:
      return { ...state, isWorldcup: action.payload }
    case actions.UPDATE_TRAVEL_GOOGLE_TAGGING_DATA:
      return { ...state, travelGoogleTaggingData: { ...state.travelGoogleTaggingData, ...action.payload } }

    case actions.UPDATE_BUSINESSLINE:
          return { ...state, businessLine: action.payload }
      
    default:
      return state;
  }
};

export default travelReducer;
